// const config = useRuntimeConfig()
// const { getEnv } = useEnv();

let apiUrlBase = ''
let stage = ''

// if (region.value === null || stage.value === null) {
//   throw new Error('Missing DEPLOYMENT_REGION or STAGE_NAME')
// }

export function setUrlStage(stageName: string) {
  stage = stageName
}


export function getUrls() {
  let suffix = ''
  if (stage !== 'prod') {
    if (stage === 'development') {
      suffix = '-dev'
    } else {
      suffix = `-${stage}`
    }
  }

  apiUrlBase = `https://global.api${suffix}.mit.edu`

  return { apiUrlBase }
}
